import { Component, Input, OnInit } from '@angular/core';
import { LandlineConsumptionInterface } from '../../models/landline-consumption.interface';

@Component({
  selector: 'app-land-line-consumption-details',
  templateUrl: './land-line-consumption-details.component.html',
  styleUrls: ['./land-line-consumption-details.component.css'],
  standalone: false
})
export class LandLineConsumptionDetailsComponent implements OnInit {

  @Input()
  landLineConsumption: LandlineConsumptionInterface;
  alternatedBackground: boolean = true;
  constructor() { }

  ngOnInit() {
    this.alternatedBackground  = true;
  }

  setBackgroundColor(index: number) {
    if (index % 2 === 0) {
      this.alternatedBackground = true;
    } else {
      this.alternatedBackground = false;
    }
    return this.alternatedBackground;
  }

}
